// @flow
import { FAQ_EMAIL, FAQ_OPEN } from '../../../ActionsConst';

export const openFaq = (error: Object = {}) => ({
  error,
  type: FAQ_OPEN,
});

export const emailFaq = () => ({
  type: FAQ_EMAIL,
});
